module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-row', {
    staticClass: "mb-3 mt-3",
    staticStyle: {
      "justify-content": "right"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('v-card-title', {
    staticClass: "pa-0"
  }, [_c('v-row', {
    staticClass: "filter-area"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('v-btn', {
    staticClass: "mb-2",
    staticStyle: {
      "margin-left": "0"
    },
    attrs: {
      "color": "secondary",
      "small": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.resetFilter()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-repeat fa-xs"
  }), _vm._v(" Reload\n            ")])], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.AM,
      "item-value": "id",
      "item-text": "name",
      "label": "AM",
      "hide-details": "",
      "outlined": "",
      "dense": ""
    },
    on: {
      "change": _vm.searchFilter
    },
    model: {
      value: (_vm.selectedFilter.AM),
      callback: function($$v) {
        _vm.$set(_vm.selectedFilter, "AM", $$v)
      },
      expression: "selectedFilter.AM"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.CC,
      "item-value": "id",
      "item-text": "name",
      "label": "CC",
      "hide-details": "",
      "outlined": "",
      "dense": ""
    },
    on: {
      "change": _vm.searchFilter
    },
    model: {
      value: (_vm.selectedFilter.CC),
      callback: function($$v) {
        _vm.$set(_vm.selectedFilter, "CC", $$v)
      },
      expression: "selectedFilter.CC"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-select', {
    staticStyle: {
      "max-width": "200px"
    },
    attrs: {
      "items": _vm.defaultYears,
      "label": "Active Year",
      "outlined": "",
      "dense": "",
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        return _vm.getCampaignCogs()
      }
    },
    model: {
      value: (_vm.selectedFilter.activeYear),
      callback: function($$v) {
        _vm.$set(_vm.selectedFilter, "activeYear", $$v)
      },
      expression: "selectedFilter.activeYear"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.totalSummary) ? _c('v-layout', {
    staticClass: "mt-0",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md3": "",
      "sm6": "",
      "xs12": "",
      "pa-3": ""
    }
  }, [_c('v-card', {
    staticClass: "small-box",
    attrs: {
      "dark": "",
      "color": "#363636",
      "min-height": "150px"
    }
  }, [_c('v-card-title', {
    staticClass: "title card-title one-line"
  }, [_vm._v("Q1")]), _vm._v(" "), (_vm.summaryItems.length) ? _c('v-card-text', [_c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Total Entries:")]), _c('span', [_vm._v(_vm._s(_vm.summaryItems[0].data.length))])]), _vm._v(" "), _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Total COGS Capped:")]), _vm._v(" "), _c('span', [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(_vm.summaryItems[0].totalValues.cappedCOGS)))])]), _vm._v(" "), _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Total COGS Used:")]), _vm._v(" "), _c('span', [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(_vm.summaryItems[0].totalValues.cogsTotal)))])]), _vm._v(" "), _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Total COGS Excess:")]), _vm._v(" "), _c('span', [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(_vm.summaryItems[0].totalValues.cogsExcess)))])]), _vm._v(" "), _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("COGS %:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.summaryItems[0].totalValues.cogsInfPercentage) + "%")])])]) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md3": "",
      "sm6": "",
      "xs12": "",
      "pa-3": ""
    }
  }, [_c('v-card', {
    staticClass: "small-box",
    attrs: {
      "dark": "",
      "color": "#363636",
      "min-height": "150px"
    }
  }, [_c('v-card-title', {
    staticClass: "title card-title one-line"
  }, [_vm._v("Q2")]), _vm._v(" "), (_vm.summaryItems.length) ? _c('v-card-text', [_c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Total Entries:")]), _c('span', [_vm._v(_vm._s(_vm.summaryItems[1].data.length))])]), _vm._v(" "), _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Total COGS Capped:")]), _vm._v(" "), _c('span', [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(_vm.summaryItems[1].totalValues.cappedCOGS)))])]), _vm._v(" "), _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Total COGS Used:")]), _vm._v(" "), _c('span', [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(_vm.summaryItems[1].totalValues.cogsTotal)))])]), _vm._v(" "), _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Total COGS Excess:")]), _vm._v(" "), _c('span', [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(_vm.summaryItems[1].totalValues.cogsExcess)))])]), _vm._v(" "), _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("COGS %:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.summaryItems[1].totalValues.cogsInfPercentage) + "%")])])]) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md3": "",
      "sm6": "",
      "xs12": "",
      "pa-3": ""
    }
  }, [_c('v-card', {
    staticClass: "small-box",
    attrs: {
      "dark": "",
      "color": "#363636",
      "min-height": "150px"
    }
  }, [_c('v-card-title', {
    staticClass: "title card-title one-line"
  }, [_vm._v("Q3")]), _vm._v(" "), (_vm.summaryItems.length) ? _c('v-card-text', [_c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Total Entries:")]), _c('span', [_vm._v(_vm._s(_vm.summaryItems[2].data.length))])]), _vm._v(" "), _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Total COGS Capped:")]), _vm._v(" "), _c('span', [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(_vm.summaryItems[2].totalValues.cappedCOGS)))])]), _vm._v(" "), _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Total COGS Used:")]), _vm._v(" "), _c('span', [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(_vm.summaryItems[2].totalValues.cogsTotal)))])]), _vm._v(" "), _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Total COGS Excess:")]), _vm._v(" "), _c('span', [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(_vm.summaryItems[2].totalValues.cogsExcess)))])]), _vm._v(" "), _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("COGS %:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.summaryItems[2].totalValues.cogsInfPercentage) + "%")])])]) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md3": "",
      "sm6": "",
      "xs12": "",
      "pa-3": ""
    }
  }, [_c('v-card', {
    staticClass: "small-box",
    attrs: {
      "dark": "",
      "color": "#363636",
      "min-height": "150px"
    }
  }, [_c('v-card-title', {
    staticClass: "title card-title one-line"
  }, [_vm._v("Q4")]), _vm._v(" "), (_vm.summaryItems.length) ? _c('v-card-text', [_c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Total Entries:")]), _c('span', [_vm._v(_vm._s(_vm.summaryItems[3].data.length))])]), _vm._v(" "), _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Total COGS Capped:")]), _vm._v(" "), _c('span', [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(_vm.summaryItems[3].totalValues.cappedCOGS)))])]), _vm._v(" "), _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Total COGS Used:")]), _vm._v(" "), _c('span', [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(_vm.summaryItems[3].totalValues.cogsTotal)))])]), _vm._v(" "), _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Total COGS Excess:")]), _vm._v(" "), _c('span', [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(_vm.summaryItems[3].totalValues.cogsExcess)))])]), _vm._v(" "), _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("COGS %:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.summaryItems[3].totalValues.cogsInfPercentage) + "%")])])]) : _vm._e()], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-row', {
    staticClass: "mb-1"
  }, [_c('v-col', {
    staticClass: "pt-0",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('div', {
    staticClass: "d-flex flex-row",
    staticStyle: {
      "justify-content": "space-between"
    }
  }, [_c('div'), _vm._v(" "), _c('div', {
    staticClass: "d-flex flex-row"
  }, [_c('div', {
    staticStyle: {
      "min-width": "150px"
    }
  }, [_c('v-menu', {
    ref: "startDatePicker",
    attrs: {
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "dense": "",
      "max-width": "350px",
      "min-width": "auto"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-text-field', _vm._g(_vm._b({
          attrs: {
            "label": "Start Month",
            "placeholder": "Start Month",
            "dense": "",
            "readonly": "",
            "outlined": "",
            "hide-details": ""
          },
          model: {
            value: (_vm.selectedFilter.startDate),
            callback: function($$v) {
              _vm.$set(_vm.selectedFilter, "startDate", $$v)
            },
            expression: "selectedFilter.startDate"
          }
        }, 'v-text-field', attrs, false), on))]
      }
    }]),
    model: {
      value: (_vm.startDateCal),
      callback: function($$v) {
        _vm.startDateCal = $$v
      },
      expression: "startDateCal"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "type": "month",
      "no-title": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.selectedFilter.startDate),
      callback: function($$v) {
        _vm.$set(_vm.selectedFilter, "startDate", $$v)
      },
      expression: "selectedFilter.startDate"
    }
  }, [_c('v-spacer')], 1)], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "date-divider"
  }, [_vm._v(" - ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "min-width": "150px"
    }
  }, [_c('v-menu', {
    ref: "endDatePicker",
    attrs: {
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "dense": "",
      "max-width": "350px",
      "min-width": "auto"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-text-field', _vm._g(_vm._b({
          staticClass: "mr-3",
          attrs: {
            "label": "End Month",
            "placeholder": "End Month",
            "dense": "",
            "readonly": "",
            "outlined": "",
            "hide-details": ""
          },
          model: {
            value: (_vm.selectedFilter.endDate),
            callback: function($$v) {
              _vm.$set(_vm.selectedFilter, "endDate", $$v)
            },
            expression: "selectedFilter.endDate"
          }
        }, 'v-text-field', attrs, false), on))]
      }
    }]),
    model: {
      value: (_vm.endDateCal),
      callback: function($$v) {
        _vm.endDateCal = $$v
      },
      expression: "endDateCal"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "type": "month",
      "no-title": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.selectedFilter.endDate),
      callback: function($$v) {
        _vm.$set(_vm.selectedFilter, "endDate", $$v)
      },
      expression: "selectedFilter.endDate"
    }
  }, [_c('v-spacer')], 1)], 1)], 1), _vm._v(" "), _c('div', [_c('v-text-field', {
    staticClass: "pt-0",
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.selectedFilter.text),
      callback: function($$v) {
        _vm.$set(_vm.selectedFilter, "text", $$v)
      },
      expression: "selectedFilter.text"
    }
  })], 1), _vm._v(" "), _c('div', [_c('v-btn', {
    staticClass: "ml-2",
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": _vm.searchFilter
    }
  }, [_vm._v("Apply")])], 1), _vm._v(" "), _c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "bottom": "",
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "icon": "",
            "color": "secondary"
          },
          on: {
            "click": _vm.openColSettingsModal
          }
        }, 'v-btn', attrs, false), on), [_c('i', {
          staticClass: "fas fa-cog fa-lg",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Settings"
          }
        })])]
      }
    }])
  })], 1)])])], 1), _vm._v(" "), _vm._l((_vm.filteredItems), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "campaign-cogs-section",
      attrs: {
        "id": item.name
      }
    }, [_c('v-expansion-panels', {
      staticClass: "expansion-panels mb-5",
      attrs: {
        "multiple": "",
        "accordion": ""
      },
      model: {
        value: (item.panel),
        callback: function($$v) {
          _vm.$set(item, "panel", $$v)
        },
        expression: "item.panel"
      }
    }, [_c('v-expansion-panel', {
      staticClass: "expansion-panel-main",
      attrs: {
        "expand": ""
      }
    }, [_c('v-expansion-panel-header', {
      staticClass: "expansion-panel-header"
    }, [_c('h3', {
      staticClass: "pa-0 ma-0"
    }, [_vm._v(_vm._s(item.title))])]), _vm._v(" "), _c('v-expansion-panel-content', {
      staticClass: "expansion-panel-content"
    }, [_c('v-row', {
      staticClass: "no-gutters"
    }, [_c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "12",
        "md": "12",
        "lg": "12"
      }
    }, [_c('v-row', {
      staticClass: "action-section mb-3"
    }, [_c('v-col', {
      staticClass: "action-group-section pl-0",
      attrs: {
        "cols": "12",
        "sm": "3",
        "md": "3",
        "lg": "3"
      }
    }, [_c('div', {
      staticClass: "d-flex flex-row",
      staticStyle: {
        "gap": "3px"
      }
    }, [_c('div', [(item.selectedCOGS && item.selectedCOGS.length > 0) ? _c('v-btn', {
      staticClass: "mb-2",
      attrs: {
        "color": "warning",
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.openQuarterUpdateModal(item.selectedCOGS)
        }
      }
    }, [_vm._v("Update Status (" + _vm._s(item.selectedCOGS.length) + ")")]) : _vm._e(), _vm._v(" "), (item.selectedCOGS && item.selectedCOGS.length > 0) ? _c('v-btn', {
      staticClass: "mb-2",
      attrs: {
        "color": "warning",
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.openActiveYearDialog(item.data)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("edit")]), _vm._v(" Update Active Year\n                      ")], 1) : _vm._e(), _vm._v(" "), _c('v-btn', {
      staticClass: "mb-2 primary",
      attrs: {
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.exportReport(item)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("mdi-file-excel")]), _vm._v(" Export Excel")], 1)], 1)])]), _vm._v(" "), _c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "9",
        "md": "9",
        "lg": "9"
      }
    }, [_c('div', {
      staticClass: "d-flex justify-content-right float-right"
    }, [_c('div', {
      staticClass: "mx-2",
      staticStyle: {
        "min-width": "150px"
      }
    }, [_c('v-text-field', {
      attrs: {
        "append-icon": "mdi-magnify",
        "label": "Search",
        "single-line": "",
        "hide-details": ""
      },
      model: {
        value: (item.filter.search),
        callback: function($$v) {
          _vm.$set(item.filter, "search", $$v)
        },
        expression: "item.filter.search"
      }
    })], 1)])])], 1)], 1), _vm._v(" "), _c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "12",
        "md": "12",
        "lg": "12"
      }
    }, [_c('v-data-table', {
      staticClass: "cogs-summary-table elevation-1",
      attrs: {
        "headers": _vm.computedHeaders,
        "search": item.filter.search,
        "items": item.data,
        "items-per-page": 15,
        "show-select": "",
        "single-select": false
      },
      on: {
        "current-items": _vm.getFiltered
      },
      scopedSlots: _vm._u([{
        key: "item.campaignName",
        fn: function(ref) {
          var item = ref.item;

          return [_c('td', {
            staticClass: "text-xs-left"
          }, [_vm._v("\n                    " + _vm._s(item.campaignName) + "\n                    "), (item.lockedCOGS) ? _c('div', [_c('v-chip', {
            attrs: {
              "color": "warning",
              "x-small": "",
              "text-color": "white"
            }
          }, [_c('v-icon', {
            attrs: {
              "small": ""
            }
          }, [_vm._v("mdi-lock")]), _vm._v(" Locked COGS\n                      ")], 1)], 1) : _vm._e()])]
        }
      }, {
        key: "item.budget",
        fn: function(ref) {
          var item = ref.item;

          return [_c('td', {
            staticClass: "text-xs-left"
          }, [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.budget)))])]
        }
      }, {
        key: "item.cappedCOGS",
        fn: function(ref) {
          var item = ref.item;

          return [_c('td', {
            staticClass: "text-center"
          }, [(item.cappedCOGS) ? _c('span', [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.cappedCOGS)))]) : _vm._e(), _vm._v(" "), (item.markupDeal) ? _c('v-chip', {
            attrs: {
              "color": "warning",
              "x-small": "",
              "text-color": "white"
            }
          }, [_vm._v("\n                      Markup COGS\n                    ")]) : _vm._e()], 1)]
        }
      }, {
        key: "item.cogsTotal",
        fn: function(ref) {
          var item = ref.item;

          return [_c('td', {
            staticClass: "text-center"
          }, [(item.cogsTotal) ? _c('span', [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.cogsTotal)))]) : _vm._e(), _vm._v(" "), (item.cogsTotal && item.cappedCOGS && item.cogsTotal > item.cappedCOGS) ? _c('v-chip', {
            attrs: {
              "color": "red",
              "x-small": "",
              "text-color": "white"
            }
          }, [_vm._v("\n                      Burst COGS\n                    ")]) : _vm._e()], 1)]
        }
      }, {
        key: "item.cogsInf",
        fn: function(ref) {
          var item = ref.item;

          return [_c('td', {
            staticClass: "text-center"
          }, [(item.cogsInf) ? _c('span', [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.cogsInf)))]) : _vm._e()])]
        }
      }, {
        key: "item.cogsNoGST",
        fn: function(ref) {
          var item = ref.item;

          return [_c('td', {
            staticClass: "text-center"
          }, [(item.cogsNoGST) ? _c('span', [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.cogsNoGST)))]) : _vm._e()])]
        }
      }, {
        key: "item.cogsOthers",
        fn: function(ref) {
          var item = ref.item;

          return [_c('td', {
            staticClass: "text-center"
          }, [(item.cogsOthers) ? _c('span', [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.cogsOthers)))]) : _vm._e()])]
        }
      }, {
        key: "item.cogsInfPercentage",
        fn: function(ref) {
          var item = ref.item;

          return [_c('td', {
            staticClass: "text-center"
          }, [(item.cogsInfPercentage) ? _c('span', [_vm._v(_vm._s(item.cogsInfPercentage) + "%")]) : _vm._e()])]
        }
      }, {
        key: "item.cogsExcess",
        fn: function(ref) {
          var item = ref.item;

          return [_c('td', {
            staticClass: "text-center"
          }, [_c('a', {
            class: _vm.getCOGSExcessColor(item.cogsExcess)
          }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.getCOGSExcessSign(item.cogsExcess))))])])]
        }
      }, {
        key: "item.completedAmt",
        fn: function(ref) {
          var item = ref.item;

          return [_c('td', {
            staticClass: "text-center"
          }, [_c('a', {
            staticClass: "custom-link",
            attrs: {
              "href": '/finance/payment-consolidation/status?id=' + item.campaignID,
              "target": "_blank"
            }
          }, [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.completedAmt)))])])]
        }
      }, {
        key: "item.pendingAmt",
        fn: function(ref) {
          var item = ref.item;

          return [_c('td', {
            staticClass: "text-center"
          }, [_c('a', {
            staticClass: "custom-link",
            attrs: {
              "href": '/finance/payment-consolidation/status?id=' + item.campaignID,
              "target": "_blank"
            }
          }, [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.pendingAmt)))])])]
        }
      }, {
        key: "item.AM",
        fn: function(ref) {
          var item = ref.item;

          return [_c('td', {
            staticClass: "text-center"
          }, [(item.AM) ? _c('span', [_vm._v("\n                      " + _vm._s(_vm.getUsersDisplay(item.AM)) + "\n                    ")]) : _vm._e()])]
        }
      }, {
        key: "item.CC",
        fn: function(ref) {
          var item = ref.item;

          return [_c('td', {
            staticClass: "text-center"
          }, [(item.CC) ? _c('span', [_vm._v("\n                      " + _vm._s(_vm.getUsersDisplay(item.CC)) + "\n                    ")]) : _vm._e()])]
        }
      }, {
        key: "item.startDate",
        fn: function(ref) {
          var item = ref.item;

          return [(item.startDateEdit === false) ? _c('div', {
            on: {
              "click": function($event) {
                return _vm.openEditItem(item, 'startDate', 'filteredItems')
              }
            }
          }, [_c('td', {
            staticClass: "text-center"
          }, [_vm._v("\n                      " + _vm._s(_vm.formatMonth(item.startDate)) + " "), _c('v-icon', {
            staticClass: "cursor-pointer",
            attrs: {
              "color": "warning",
              "x-small": ""
            }
          }, [_vm._v("edit")])], 1)]) : _c('div', [_c('td', {
            staticClass: "text-xs-left",
            staticStyle: {
              "min-width": "120px"
            }
          }, [_c('v-menu', {
            attrs: {
              "close-on-content-click": false,
              "nudge-right": 40,
              "transition": "scale-transition",
              "offset-y": "",
              "min-width": "290px"
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('v-text-field', _vm._g({
                  staticClass: "input-field mt-3",
                  attrs: {
                    "append-icon": "event",
                    "readonly": "",
                    "dense": "",
                    "outlined": ""
                  },
                  model: {
                    value: (item.startDate),
                    callback: function($$v) {
                      _vm.$set(item, "startDate", $$v)
                    },
                    expression: "item.startDate"
                  }
                }, on))]
              }
            }], null, true),
            model: {
              value: (item.startCal),
              callback: function($$v) {
                _vm.$set(item, "startCal", $$v)
              },
              expression: "item.startCal"
            }
          }, [_vm._v(" "), _c('v-date-picker', {
            attrs: {
              "type": "month"
            },
            on: {
              "input": function($event) {
                item.startCal = false
              }
            },
            model: {
              value: (item.startDate),
              callback: function($$v) {
                _vm.$set(item, "startDate", $$v)
              },
              expression: "item.startDate"
            }
          })], 1)], 1)])]
        }
      }, {
        key: "item.endDate",
        fn: function(ref) {
          var item = ref.item;

          return [(item.endDateEdit === false) ? _c('div', {
            on: {
              "click": function($event) {
                return _vm.openEditItem(item, 'endDate', 'filteredItems')
              }
            }
          }, [_c('td', {
            staticClass: "text-center"
          }, [_vm._v("\n                      " + _vm._s(_vm.formatMonth(item.endDate)) + " "), _c('v-icon', {
            staticClass: "cursor-pointer",
            attrs: {
              "color": "warning",
              "x-small": ""
            }
          }, [_vm._v("edit")])], 1)]) : _c('div', [_c('td', {
            staticClass: "text-xs-left",
            staticStyle: {
              "min-width": "120px"
            }
          }, [_c('v-menu', {
            attrs: {
              "close-on-content-click": false,
              "nudge-right": 40,
              "transition": "scale-transition",
              "offset-y": "",
              "min-width": "290px"
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('v-text-field', _vm._g({
                  staticClass: "input-field mt-3",
                  attrs: {
                    "append-icon": "event",
                    "readonly": "",
                    "dense": "",
                    "outlined": ""
                  },
                  model: {
                    value: (item.endDate),
                    callback: function($$v) {
                      _vm.$set(item, "endDate", $$v)
                    },
                    expression: "item.endDate"
                  }
                }, on))]
              }
            }], null, true),
            model: {
              value: (item.endCal),
              callback: function($$v) {
                _vm.$set(item, "endCal", $$v)
              },
              expression: "item.endCal"
            }
          }, [_vm._v(" "), _c('v-date-picker', {
            attrs: {
              "type": "month"
            },
            on: {
              "input": function($event) {
                item.endCal = false
              }
            },
            model: {
              value: (item.endDate),
              callback: function($$v) {
                _vm.$set(item, "endDate", $$v)
              },
              expression: "item.endDate"
            }
          })], 1)], 1)])]
        }
      }, {
        key: "item.startMonth",
        fn: function(ref) {
          var item = ref.item;

          return [_c('div', [_c('td', {
            staticClass: "text-center"
          }, [_vm._v("\n                      " + _vm._s(_vm.formatMonth(item.startMonth)) + "\n                    ")])])]
        }
      }, {
        key: "item.endMonth",
        fn: function(ref) {
          var item = ref.item;

          return [_c('div', [_c('td', {
            staticClass: "text-center"
          }, [_vm._v("\n                      " + _vm._s(_vm.formatMonth(item.endMonth)) + "\n                    ")])])]
        }
      }, {
        key: "item.action",
        fn: function(ref) {
          var item = ref.item;

          return [_c('td', {
            staticClass: "text-center",
            staticStyle: {
              "width": "170px"
            }
          }, [(item.lockedCOGS && _vm.isAdmin) ? _c('v-btn', {
            attrs: {
              "small": "",
              "color": "warning"
            },
            on: {
              "click": function($event) {
                return _vm.changeLock(item, false)
              }
            }
          }, [_c('v-icon', {
            attrs: {
              "color": "white",
              "small": ""
            }
          }, [_vm._v("mdi-lock-open")]), _vm._v(" Unlock\n                    ")], 1) : _vm._e(), _vm._v(" "), (!item.lockedCOGS && _vm.isAdmin) ? _c('v-btn', {
            attrs: {
              "small": "",
              "color": "error"
            },
            on: {
              "click": function($event) {
                return _vm.changeLock(item, true)
              }
            }
          }, [_c('v-icon', {
            attrs: {
              "color": "white",
              "small": ""
            }
          }, [_vm._v("mdi-lock")]), _vm._v(" Lock\n                    ")], 1) : _vm._e(), _vm._v(" "), (_vm.isAdmin) ? _c('v-btn', {
            staticClass: "ims-action",
            attrs: {
              "small": "",
              "color": "success"
            },
            on: {
              "click": function($event) {
                return _vm.showPairedAdminViewDialog(item)
              }
            }
          }, [_c('v-icon', {
            attrs: {
              "color": "white",
              "small": "",
              "data-toggle": "tooltip",
              "data-placement": "top",
              "title": "View Influencers"
            }
          }, [_vm._v("people")])], 1) : _vm._e(), _vm._v(" "), _c('v-btn', {
            staticClass: "mb-2",
            attrs: {
              "color": "secondary",
              "small": ""
            },
            on: {
              "click": function($event) {
                $event.stopPropagation();
                return _vm.reloadManually(item.campaignID)
              }
            }
          }, [_c('i', {
            staticClass: "fa fa-repeat fa-xs"
          })]), _vm._v(" "), _c('v-btn', {
            staticClass: "mb-2",
            attrs: {
              "to": '/influencers/invoices-brief-confirmation?id=' + item.campaignID,
              "target": "_blank",
              "color": "warning",
              "small": ""
            }
          }, [_c('v-icon', {
            attrs: {
              "small": ""
            }
          }, [_vm._v("mdi-file-outline")]), _vm._v(" Invoices & Brief\n                  ")], 1)], 1)]
        }
      }], null, true),
      model: {
        value: (item.selectedCOGS),
        callback: function($$v) {
          _vm.$set(item, "selectedCOGS", $$v)
        },
        expression: "item.selectedCOGS"
      }
    }, [_vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _c('template', {
      slot: "body.append"
    }, [_c('tr', [_c('th', {
      staticClass: "subtitle-2"
    }, [_vm._v("Total:")]), _vm._v(" "), _vm._l((_vm.computedHeaders), function(cItem, index) {
      return _c('th', {
        key: index,
        staticClass: "text-center"
      }, [(item.totalValues && item.totalValues[cItem.value]) ? _c('v-chip', {
        staticClass: "summary-chip",
        attrs: {
          "small": "",
          "color": "primary",
          "text-color": "white"
        }
      }, [_c('v-icon', {
        staticClass: "mr-0",
        attrs: {
          "small": "",
          "left": ""
        }
      }, [_vm._v("mdi-currency-usd")]), _vm._v(" " + _vm._s(_vm._f("thousandSeprator")(item.totalValues[cItem.value])) + "\n                      ")], 1) : _vm._e()], 1)
    })], 2)])], 2)], 1)], 1)], 1)], 1)], 1)], 1)
  }), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "90",
      "height.number": "90"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('paired-inf-admin-view-dialog', {
    attrs: {
      "value": _vm.pairedInfAdminViewDialog,
      "campaign": _vm.pairedCampaign,
      "clients": _vm.allClients
    },
    model: {
      value: (_vm.pairedInfAdminViewDialog),
      callback: function($$v) {
        _vm.pairedInfAdminViewDialog = $$v
      },
      expression: "pairedInfAdminViewDialog"
    }
  }), _vm._v(" "), _c('update-quarter-modal', {
    attrs: {
      "value": _vm.quarterUpdateialog,
      "selectedCOGS": _vm.selectedCOGS
    },
    on: {
      "updated": _vm.getCampaignCogs
    },
    model: {
      value: (_vm.quarterUpdateialog),
      callback: function($$v) {
        _vm.quarterUpdateialog = $$v
      },
      expression: "quarterUpdateialog"
    }
  }), _vm._v(" "), _c('table-cols-show-hide-modal', {
    attrs: {
      "title": "Campaign COGS",
      "items": _vm.tableColsItems
    },
    on: {
      "updated": _vm.updateTableCols
    },
    model: {
      value: (_vm.colSettingsDialog),
      callback: function($$v) {
        _vm.colSettingsDialog = $$v
      },
      expression: "colSettingsDialog"
    }
  }), _vm._v(" "), (_vm.totalSummary) ? _c('projected-cogs-modal', {
    attrs: {
      "value": _vm.projectedCogsDialog,
      "monthYearValues": _vm.totalSummary.revsForMonthYear
    },
    model: {
      value: (_vm.projectedCogsDialog),
      callback: function($$v) {
        _vm.projectedCogsDialog = $$v
      },
      expression: "projectedCogsDialog"
    }
  }) : _vm._e(), _vm._v(" "), _c('active-year-modal', {
    attrs: {
      "value": _vm.activeYearDialog,
      "items": _vm.selectedCOGS,
      "campaigns": _vm.editCampaigns
    },
    on: {
      "updated": _vm.getCampaignCogs
    },
    model: {
      value: (_vm.activeYearDialog),
      callback: function($$v) {
        _vm.activeYearDialog = $$v
      },
      expression: "activeYearDialog"
    }
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f7abdb72"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Campaign/COGSSummary/DataTable.vue
// module id = 2323
// module chunks = 0